import { render, staticRenderFns } from "./fbpdfbox.vue?vue&type=template&id=07d7affa&scoped=true&"
import script from "./fbpdfbox.vue?vue&type=script&lang=js&"
export * from "./fbpdfbox.vue?vue&type=script&lang=js&"
import style0 from "./fbpdfbox.vue?vue&type=style&index=0&id=07d7affa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7affa",
  null
  
)

export default component.exports